import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import styles from "./Modal.module.css";
import classNames from "classnames";

export const Modal = ({ isOpen, children, className, header, footer }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setShow(true);
    } else {
      const timer = setTimeout(() => setShow(false), 300);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  return (
    <>
      {show && isOpen && <div className={styles.modalBackdrop}></div>}
      {show && (
        <div
          className={classNames(className, styles.modal, {
            [styles.show]: isOpen,
          })}
        >
          <div
            className={classNames(
              "modal-dialog modal-dialog-centered modal-lg"
            )}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title fs-5">{header}</h1>
              </div>
              <div className="modal-body">{children}</div>
              <div className="modal-footer">{footer}</div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  header: PropTypes.string.isRequired,
  footer: PropTypes.node,
};

export default Modal;
